import React from "react";
import Chart from "react-apexcharts";
import { COLORES_COMPRA } from "./constants";
import { formatCurrency, formatMontoEje, truncarNombre } from "./utils";

export default function GraficoTopCompra(props) {
    const datos = props.datos || [];
    const moneda = props.moneda || "PEN";
    const simbolo = moneda === "USD" ? "US$" : "S/";
    const valores = datos.map((item) => item.total);

    const options = {
        chart: {
            type: "bar",
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: "55%",
                borderRadius: 4,
                // Un color distinto por barra para que cada proveedor se
                // identifique en la leyenda (que muestra el monto).
                distributed: true,
            },
        },
        colors: COLORES_COMPRA,
        // El monto no se escribe encima de la barra (se corta o queda
        // centrado segun el ancho disponible); en su lugar se muestra en una
        // leyenda fija, siempre visible sin pasar el mouse.
        dataLabels: { enabled: false },
        xaxis: {
            categories: datos.map((item) => item.nombre),
            title: { text: `Compras (${simbolo})` },
            labels: { formatter: formatMontoEje },
        },
        yaxis: {
            labels: { formatter: (val) => truncarNombre(String(val)) },
        },
        legend: {
            show: true,
            showForSingleSeries: true,
            position: "right",
            verticalAlign: "middle",
            fontSize: "12px",
            itemMargin: { vertical: 4 },
            formatter: (nombre, opts) => ` ${formatCurrency(valores[opts.seriesIndex], moneda)}`,
        },
        tooltip: {
            x: {
                formatter: (val) => truncarNombre(val),
            },
            y: {
                formatter: (val) => formatCurrency(val, moneda),
            },
        },
        grid: {
            padding: { left: 10, right: 10 },
        },
        noData: { text: "Sin compras en el periodo" },
        // En pantallas angostas la leyenda a la derecha aprieta las barras;
        // ahi se pasa a leyenda inferior (mismo criterio que la dona).
        responsive: [
            {
                breakpoint: 992,
                options: {
                    legend: {
                        position: "bottom",
                        verticalAlign: "middle",
                        itemMargin: { horizontal: 8, vertical: 4 },
                    },
                },
            },
        ],
    };

    // Igual que en la dona: los formatters de la leyenda son funciones y
    // react-apexcharts no detecta su cambio; la key fuerza el remontaje.
    const claveDatos = datos.map((item) => `${item.nombre}:${item.total}`).join("|");

    return (
        <Chart
            key={`${moneda}-${claveDatos}`}
            options={options}
            series={[{ name: "Compras", data: valores }]}
            type="bar"
            height={320}
        />
    );
}
